export default __webpack_public_path__ + "static/media/pm_foto.5abb5383.jpg";